import { render, staticRenderFns } from "./invoiceList.vue?vue&type=template&id=c0b1d402&scoped=true"
import script from "./invoiceList.vue?vue&type=script&lang=js"
export * from "./invoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b1d402",
  null
  
)

export default component.exports